import { createApp } from 'vue'
import popover from '@/directives/popover'
import select2 from '@/directives/select2'
import App from './App.vue'
import router from './router'
import store from './store'

const $ = require('jquery')

window.$ = $

createApp(App)
  .use(store)
  .use(router)
  .directive('select2', select2)
  .directive('popover', popover)
  .mount('#app')
